import { render, staticRenderFns } from "./CR_overseasTransportation.vue?vue&type=template&id=1311d7eb&scoped=true&"
import script from "./CR_overseasTransportation.vue?vue&type=script&lang=js&"
export * from "./CR_overseasTransportation.vue?vue&type=script&lang=js&"
import style0 from "./CR_overseasTransportation.vue?vue&type=style&index=0&id=1311d7eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311d7eb",
  null
  
)

export default component.exports